import { RefObject, useState } from 'react';
import * as R from 'remeda';
import { useIntl } from 'react-intl';
import { Header } from '@rossum/components/header/Header';
import { Button } from '@rossum/ui/material';
import { SettingsBreadcrumbs } from '../../../containers/Settings/SettingsBreadcrumbs';
import { AddQueueDialog } from '../../queue-sidebar/add-queue/AddQueueDialog';
import { AddWorkspaceModal } from '../../queue-sidebar/sidebar/components/AddWorkspaceModal';

type QueueManagerHeaderProps = {
  scrollableDivRef: RefObject<HTMLDivElement>;
};

export const QueueManagerHeader = ({
  scrollableDivRef,
}: QueueManagerHeaderProps) => {
  const intl = useIntl();

  const [isAddQueueDialogOpen, setIsAddQueueDialogOpen] = useState(false);
  const [isAddWorkspaceModalOpen, setIsAddWorkspaceModalOpen] = useState(false);

  return (
    <>
      <Header
        scrollableDivRef={scrollableDivRef}
        description={intl.formatMessage({
          id: 'features.queueManager.description',
        })}
        breadcrumbs={
          <SettingsBreadcrumbs
            breadcrumbs={[
              {
                label: intl.formatMessage({
                  id: 'features.queueManager.title',
                }),
              },
            ]}
          />
        }
        title={intl.formatMessage({
          id: 'features.queueManager.title',
        })}
        buttons={[
          <Button
            key="add-workspace"
            variant="outlined"
            color="secondary"
            onClick={() => setIsAddWorkspaceModalOpen(true)}
          >
            {intl.formatMessage({
              id: 'features.queueManager.actions.addWorkspace',
            })}
          </Button>,
          <Button
            key="add-queue"
            variant="contained"
            onClick={() => setIsAddQueueDialogOpen(true)}
          >
            {intl.formatMessage({
              id: 'features.queueManager.actions.addQueue',
            })}
          </Button>,
        ]}
      />

      <AddQueueDialog
        open={isAddQueueDialogOpen}
        onClose={() => setIsAddQueueDialogOpen(false)}
        onSuccess={R.doNothing}
      />

      <AddWorkspaceModal
        open={isAddWorkspaceModalOpen}
        onClose={() => setIsAddWorkspaceModalOpen(false)}
      />
    </>
  );
};
